import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
	styled,
} from '@volkswagen-onehub/components-core';
import { Checkmark } from '@volkswagen-onehub/icons-core';
import React from 'react';

const IconStyled = styled.div`
	color: white;
	width: 64px;
	height: 64px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: #001e50;
`;

const StyledContainer = styled(Container)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const VWBookParticipado: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<StyledContainer wrap={'always'} stretchContent>
				<IconStyled>
					<Checkmark />
				</IconStyled>
			</StyledContainer>

			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					<Text bold>Ya hemos registrado tu solicitud</Text>
					{'\u0020y muy pronto podrás disfrutar de tu libro'}
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						En unos días, nos pondremos en contacto contigo para que puedas pasar a recogerlo en el punto de venta que
						has seleccionado.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0120,
						bottom: ContainerPadding.dynamic0140,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						¡Esperamos que te guste y lo disfrutes!
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
